const config = {
    baseUrl: 'https://api.bizzabo.com',
    authCookieAccess: 'x-bz-access-attendee-token',
    eventsUrl: 'https://events.bizzabo.com',
    previewCookieName: 'x-bz-preview',
    cloudinaryCloudName: 'bizzaboprod',
    cloudinaryUploadPreset: 'getgadzy',
    snowplowDevelopmentEndpoint: 'com-bizzabo-prod1.mini.snplow.net',
    snowplowProductionEndpoint: 'sp.bizzabo.com',
    snowplowSourceEndpoint: 'https://cdnjs.cloudflare.com/ajax/libs/snowplow/2.16.3/sp.js',
    getStreamKey: 'pf25u7jv6uat',
    environment: 'production',
};

export default config;
